import React from "react";
import HeroImg from "../Assets/img/hero-img.png";
import { Link } from "react-router-dom";
const Hero = () => {
  return (
    <>
      {/* <!-- Hero-Area --> */}
      <section className="hero-area">
        <div className="hero-circle"></div>
        {/* <!-- Single-Slider --> */}
        <div className="single-slider">
          <div className="container">
            <div className="row">
              <div className="col-lg-5 col-md-8 col-12">
                <div className="hero-content">
                  <h1>ISP Management & Billing Software</h1>
                  <p>
                    A widely chosen ERP for ISP Industry that ensures all the
                    requirements of ISP Business.
                  </p>
                  <div className="hero-btn">
                    <Link to="/websubscription" className="theme-btn primary">
                      Package & Pricing
                    </Link>
                    <Link to="/demorequest" className="theme-btn">
                      Demo Request
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col-lg-7 col-md-6 col-12">
                {/* <!-- Hero Image --> */}
                <div className="hero-img">
                  <div className="hero-img-slider">
                    <div className="single-img-slider">
                      <img src={HeroImg} alt="#" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- End-Hero-Area -->	 */}
    </>
  );
};

export default Hero;
